import { render, staticRenderFns } from "./NationalSheet.vue?vue&type=template&id=efc0cf20&scoped=true&"
import script from "./NationalSheet.vue?vue&type=script&lang=js&"
export * from "./NationalSheet.vue?vue&type=script&lang=js&"
import style0 from "./NationalSheet.vue?vue&type=style&index=0&id=efc0cf20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc0cf20",
  null
  
)

export default component.exports